import { client, cachePersistor } from '@xbcb/apollo-client';

export const apolloLogout = async (): Promise<void> => {
  await cachePersistor.purge();
  client.clearStore();
};
